import dispatcher from '../dispatcher';

var elementProto = Object.create(HTMLInputElement.prototype);

var _setValue = function(value, noEvent) {
	var event;

	if (value === undefined) return;
	this.value = value;

	if (!noEvent) {
		event = new Event('change');
		this.dispatchEvent(event);
	}
}

var _getData = function() {
	return {
		value: this.value,
		default: this._defaultValue
	}
}

var _setData = function(data) {
	if (data.value) {
		this.setValue(data.value);
	}
}

var _reset = function() {
	this.setValue(this._defaultValue);
}

elementProto.createdCallback = function() {
	this.reset = _reset.bind(this);
	this.getData = _getData.bind(this);
	this.setData = _setData.bind(this);
	this.setValue = _setValue.bind(this);
}
elementProto.attachedCallback = function() {
	this._defaultValue = '';
}
elementProto.detachedCallback = function() {
}

document.registerElement('simple-input', {
	prototype: elementProto,
	extends: 'input'
});